<!--
  Campo di testo con etichetta.
-->
<template>
  <div :style="style">
    <el-form-item
      :label="title"
      :style="styleForm"
      :prop="prop"
    >
      <el-input
        v-model="internalValue"
        :placeholder="placeholder"
        :disabled="disabled"
        :class="{ highlight: highlight }"
        @focus="handleInputFocus"
        @blur="handleInputBlur"
        @keydown.tab="handleTabKey"
      />
    </el-form-item>
  </div>
</template>

<script>

export default {
  props: {
    title: {
      type: String,
      required: false,
    },
    label: {
      type: String,
      required: true,
    },
    prop: {
      type: String,
      required: false,
    },
    placeholder: {
      type: String,
      required: true,
    },
    value: {
      type: String,
      required: true,
    },
    span: {
      type: Number,
      required: false,
      default: 3,
    },
    style: {
      type: String,
      required: false,
    },
    styleForm: {
      type: String,
      required: false,
    },
    highlight: {
      type: Boolean,
      require: false,
    },

    divWidth:{
      type:String
    },
    disabled:{
      type:Boolean,
      default:false
    }
  },
  // ⚠️ `emits` va dichiarato, e non per forma.
  //
  // I genitori ascoltano `@input` per ricevere il TESTO del campo, che questo
  // componente emette all'uscita dal campo. Senza `emits`, per Vue 3 quel
  // listener è un attributo ereditato e finisce sul <div> radice: lì arriva
  // anche l'evento `input` NATIVO dell'<input> interno, a ogni tasto. Il
  // genitore riceveva così un oggetto InputEvent al posto del testo, lo
  // rimandava giù in `value`, e il campo mostrava «[object InputEvent]» e non
  // si lasciava scrivere.
  //
  // Il difetto è nato col refactor che ha unificato i due rami `v-if`: con due
  // nodi radice Vue non applica gli attributi ereditati, con uno solo sì.
  // Riguardava tutti i campi costruiti con questo componente (indirizzi di
  // pickup e transfer, anagrafica cliente, auto, preventivatore), non solo la
  // ricerca per email.
  emits: ['input', 'focus', 'blur'],
  data() {
    return {
      internalValue: this.value,
      fieldsOfInterest: ['address', 'cap', 'province', 'street_number', 'city'],
    };
  },
  watch: {
    value(newValue) {
      this.internalValue = newValue;
    }
  },
  methods: {

    handleInputFocus() {
      this.$emit('focus');
    },
    handleInputBlur(){
      this.$emit('blur');
      this.$emit('input', this.internalValue);
    },
    handleTabKey() {
    this.handleInputBlur();
  }

  },
};
</script>

<style scoped>
/* Campo in errore.

   ⚠️ Era `border: 2px solid rgb(205, 54, 54)` su `.el-input`, che pero' non
   disegna il proprio bordo: lo fa il wrapper interno con una `box-shadow`.
   Si vedevano due cornici sfalsate, e i 2px in piu' disallineavano il campo
   rispetto a quelli accanto. Ora si ricolora l'anello che c'e' gia', quindi
   la geometria resta identica. */
.highlight :deep(.el-input__wrapper) {
  box-shadow: 0 0 0 1px var(--color-danger, #EF4444) inset !important;
}
</style>
